import { Link } from 'react-router-dom';
import EditProfileIcon from '../Icons/EditProfileIcon';
import CustomNavLink from '../CustomNavLink/CustomNavLink';
import GetUnlimited from '../GetUnlimited/GetUnlimited';
import Navigation from '../Navigation/Navigation';

interface ISideBar {
  props: any;
  openVideoModal: (params: boolean) => void;
  openLogOutModal: (params: boolean) => void;
  openEditModal: (params: boolean) => void;
  upgradeModal: (params: boolean) => void;
  isMobile: boolean;
}
export default function SideBar({
  props,
  openVideoModal,
  openLogOutModal,
  openEditModal,
  upgradeModal,
  isMobile,
}: ISideBar) {
  return (
      <div
      className={
        'bg-primary tablet:p-8 z-50 basis-[300px] group-[.fullModalOpen]:max-tablet:!z-50 flex-shrink-0 max-tablet:fixed max-tablet:bottom-0 max-tablet:w-full max-tablet:px-5 max-tablet:py-2 max-tablet:rounded-t-20'
      }
    >
      <div
        className={
          'text-center overflow-y-auto customScroll flex flex-col gap-10 justify-between h-full'
        }
      >
        <div>
          {!isMobile && (
            <Link to='/dashboard' className={'inline-block mb-16'}>
              <img
                src={'img/rr-logo.png'}
                alt={'RumbleRank Logo'}
                width={'124'}
                height={'96'}
              />
            </Link>
          )}
          <div className={'flex flex-col gap-12'}>
            {!isMobile && props.ready && (
              <div>
                <p className={'text-24 font-semibold mb-2'}>
                  {props.user?.companyName}
                </p>
                <p className={'text-15 mb-4'}>{props.user?.email}</p>
                <button
                  type={'button'}
                  className={
                    'inline-flex border border-white rounded-20 items-center gap-2 h-7 text-12 leading-1 py-0.5 px-4'
                  }
                  onClick={() => openEditModal(true)}
                >
                  <EditProfileIcon />
                  Edit profile
                </button>
              </div>
            )}
            {props.ready && (
              <Navigation openVideoModal={openVideoModal} props={props} />
            )}
            {props.user?.subscriptionTier === 'Free' && !isMobile && (
              <GetUnlimited variant={'sideBar'} upgradeModal={upgradeModal} />
            )}
          </div>
        </div>
        {!isMobile && props.ready && (
          <CustomNavLink
            variant={'logOut'}
            label={'Log out'}
            onClick={openLogOutModal}
            to={'#'}
          />
        )}
      </div>
    </div>
  );
}
